import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['modalBg', 'modal', 'trigger']


    open(event) {
        this.modalBgTarget.classList.remove('hidden')
        this.modalTarget.classList.remove('hidden')
    }

    openWithChart() {
        this.modalBgTarget.classList.remove('hidden')
        this.modalTarget.classList.remove('hidden')
        let chartElement = this.modalTarget.querySelector("#chart-container")
        const chartHTML = `<div data-controller="apache-echarts" data-apache-echarts-data-value="lz${chartElement.dataset.childId}"
           style="height:80vh;width:100%">
        <script type="text/javascript">
          window['lz${chartElement.dataset.childId}'] = ${chartElement.dataset.chartJson};
          console.log('loaded');
        </script>
      </div>
    `
        this.modalTarget.querySelector("#chart-container").innerHTML = chartHTML

    }

    close(event) {
        this.modalBgTarget.classList.add('hidden')
        this.modalTarget.classList.add('hidden')
    }

    addSpinner() {
        var loading = this.element.getElementsByClassName('loading_spinner')
        if (loading.length <= 1) {
            loading[0].innerHTML = '<span><i data-lucide="loader-circle" class="w-4 h-4 inline animate-spin"></i> Loading...</span>&nbsp;'
            if (window.lucide) window.lucide.createIcons()
        }

    }

    handleClose(event) {
        this.close()
    }

}
